import { useEffect, useState } from "react";

export default function ContabilidadGeneral() {
  const [datos, setDatos] = useState([]);

  const [entrada, setEntrada] = useState({
    descripcion: "",
    manoObra: "",
    indirectos: "",
    servicios: "",
    unitario: "",
  });

  useEffect(() => {
    const almacenados = JSON.parse(localStorage.getItem("contabilidad")) || [];
    setDatos(almacenados);
  }, []);

  const agregarDato = () => {
    const total = [
      parseFloat(entrada.manoObra || 0),
      parseFloat(entrada.indirectos || 0),
      parseFloat(entrada.servicios || 0),
      parseFloat(entrada.unitario || 0),
    ].reduce((a, b) => a + b, 0);

    const nuevoDato = { ...entrada, total };
    const actualizados = [...datos, nuevoDato];
    setDatos(actualizados);
    localStorage.setItem("contabilidad", JSON.stringify(actualizados));

    setEntrada({ descripcion: "", manoObra: "", indirectos: "", servicios: "", unitario: "" });
  };

  const totalFinal = datos.reduce((acc, d) => acc + d.total, 0);

  return (
    <div className="container">
      <h1 className="title has-text-gold">Contabilidad</h1>

      {/* Formulario */}
      <div className="columns is-multiline">
        {["descripcion", "manoObra", "indirectos", "servicios", "unitario"].map((campo, i) => (
          <div className="column is-one-fifth" key={i}>
            <input
              className="input"
              type={campo === "descripcion" ? "text" : "number"}
              placeholder={campo === "descripcion" ? "Descripción" : campo[0].toUpperCase() + campo.slice(1)}
              value={entrada[campo]}
              onChange={(e) => setEntrada({ ...entrada, [campo]: e.target.value })}
            />
          </div>
        ))}
      </div>

      <button onClick={agregarDato} className="button has-bg-gold has-text-darkblue mb-5">
        Agregar
      </button>

      {/* Tabla */}
      <div className="table-container">
        <table className="table is-fullwidth is-bordered has-text-white">
          <thead>
            <tr className="has-bg-darkblue has-text-gold">
              <th>Descripción</th>
              <th>Mano de Obra</th>
              <th>Indirectos</th>
              <th>Servicios</th>
              <th>Unitario</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {datos.map((d, i) => (
              <tr key={i} className="has-text-white">
                <td>{d.descripcion}</td>
                <td>${d.manoObra}</td>
                <td>${d.indirectos}</td>
                <td>${d.servicios}</td>
                <td>${d.unitario}</td>
                <td className="has-text-weight-bold">${d.total}</td>
              </tr>
            ))}
            <tr className="has-bg-gold has-text-darkblue has-text-weight-bold">
              <td colSpan="5" className="has-text-centered">Total General</td>
              <td>${totalFinal}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
